import { genericError } from '../../../../models/placeholder';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { GenericModalComponent } from '../../modals/generic-modal/generic-modal.component';
import { AccountService } from 'src/app/services/user/account.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UiService } from 'src/app/services/ui.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
@Component({
  selector: 'generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss'],
})
export class GenericErrorComponent implements OnInit {
  image: string;
  partnerPid: string;
  constructor(
    private router: Router,
    private modalController: ModalController,
    private navCtrl: NavController,
    private accountService: AccountService,
    private translate: TranslateService,
    private uiService: UiService,
    private theme: ThemeService,
    private analyticsService: AnalyticsService
  ) {
    this.image = genericError;
  }
  ngOnInit() {
    this.partnerPid = this.theme.getAppPid;
  }

  reloadCurrentRoute() {
    this.analyticsService.trackUnified('try_again_clicked', {
      flow: 'error',
      outcome: 'na',
      legacy_event_name: 'button_clicked',
      component: 'generic-error-component',
      button: 'try-again-button',
    });
    if (this.uiService.reloadCount > 1) {
      this.uiService.reloadCount = 0;
      this.resetSession();
    }
    this.uiService.reloadCount++;
    this.uiService.reloadPage();
  }

  async resetSession() {
    const modal = await this.modalController.create({
      component: GenericModalComponent,
      componentProps: {
        icon: 'TX_DANGER_ICON',
        message: this.translate.instant(
          'page_status.generic_error.session_has_expired_please_login_again'
        ),
        isPrompt: false,
      },
      showBackdrop: true,
      cssClass: 'generic-modal',
    });
    modal.onDidDismiss().then(() => {
      try {
        this.accountService.logout();
      } catch (error) {}
      this.uiService.reloadPage('/home');
    });
    return await modal.present();
  }

  goBack(): void {
    this.uiService.reloadPage('/home');
  }
}
